import { useEffect, useState } from 'react'

import { checkIfFreeShippingEnabled } from '@/helpers/checkIfFreeShippingEnabled'

export const useIsFreeShippingEnabled = (): boolean => {
  const [isFreeShippingEnabled, setIsFreeShippingEnabled] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const result = await checkIfFreeShippingEnabled()
      setIsFreeShippingEnabled(result)
    }

    fetchData()
  }, [])

  return isFreeShippingEnabled
}
